// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFeedUpcomingBody = {
  leagueIds: string[];
  perLeagueLimit: number;
  windowDays: number;
  timeZone: string;
  teamIds?: string[];
};

export type typeFeedUpcomingOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    sections: {
      leagueId: string;
      nextKickoffAt?: string | null;
      events: {
        eventId: string;
        leagueId: string;
        seasonId: string;
        kickoffAt: string;
        status:
          | "scheduled"
          | "inProgress"
          | "final"
          | "postponed"
          | "canceled"
          | "delayed";
        statusLabel: string;
        statusDetail?: string | null;
        isLive: boolean;
        isKickoffPassed: boolean;
        winnerTeamId?: string | null;
        isTie: boolean;
        home: {
          teamId: string;
          name: string;
          abbreviation: string;
          logoMediaId?: string | null;
          primaryColorHex?: string | null;
          score?: number | null;
          recordLabel?: string | null;
          logoUrl?: string | null;
          shortName?: string | null;
          pollRankLabel?: string | null;
        };
        away: {
          teamId: string;
          name: string;
          abbreviation: string;
          logoMediaId?: string | null;
          primaryColorHex?: string | null;
          score?: number | null;
          recordLabel?: string | null;
          logoUrl?: string | null;
          shortName?: string | null;
          pollRankLabel?: string | null;
        };
        liveState?: {
          possessionTeamId?: string | null;
          baseball?: {
            balls: number;
            strikes: number;
            outs: number;
            isFirstOccupied: boolean;
            isSecondOccupied: boolean;
            isThirdOccupied: boolean;
            countLabel: string;
            outsLabel: string;
            pitcher?: { name: string; lineLabel: string | null } | null;
            batter?: { name: string; lineLabel: string | null } | null;
          } | null;
          football?: {
            ballSpotLabel: string;
            ballSpotPercentFromAway: number;
            firstDownPercentFromAway?: number | null;
            driveStartPercentFromAway?: number | null;
            driveSummaryLabel?: string | null;
          } | null;
          summaryLabel: string;
          downAndDistanceLabel?: string | null;
          hockey?: { powerPlayTeamId: string; powerPlayLabel: string } | null;
        } | null;
        hasAlertsOn?: boolean;
        startingPitchers?: {
          away?: {
            name: string;
            playerId?: string | null;
            record?: string | null;
            era?: string | null;
          } | null;
          home?: {
            name: string;
            playerId?: string | null;
            record?: string | null;
            era?: string | null;
          } | null;
        } | null;
        pregameLine?: { label: string; spokenLabel: string } | null;
      }[];
    }[];
    refreshAfterSeconds?: number | null;
  };
};

export type typeFeedUpcomingOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFeedUpcomingOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFeedUpcomingOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFeedUpcomingBody = {
  type: "object",
  properties: {
    leagueIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
    perLeagueLimit: { type: "integer" },
    windowDays: { type: "integer" },
    timeZone: { type: "string", maxLength: 3000, minLength: 1 },
    teamIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["leagueIds", "perLeagueLimit", "windowDays", "timeZone"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFeedUpcoming(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFeedUpcomingBody);
  }

  return async function postFeedUpcoming(
    payload: typeFeedUpcomingBody,
  ): Promise<typeFeedUpcomingOutput200 | typeFeedUpcomingOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFeedUpcoming" failed before calling the network. #8298583d6ec6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#8298583d6ec6" },
        },
        data: null,
      } as typeFeedUpcomingOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/feed/upcoming`,
      httpMethod: "POST",
      options,
    })) as typeFeedUpcomingOutput200 | typeFeedUpcomingOutput400;
  };
}
